var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.325,
    height: 17.051,
    viewBox: "0 0 23.325 17.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail_1_",
    "data-name": "mail (1)",
    d: "M37.459,82.7H19.41a2.39,2.39,0,0,0-2.388,2.388V96.863a2.39,2.39,0,0,0,2.388,2.388h18.05a2.39,2.39,0,0,0,2.388-2.388V85.088A2.39,2.39,0,0,0,37.459,82.7Zm-4.245,8.272,5.678-4.456v9.968Zm-13.8-7.317h18.05a1.434,1.434,0,0,1,1.433,1.433V85.3L29.7,92.513a1.909,1.909,0,0,1-2.352,0L17.977,85.3v-.213A1.434,1.434,0,0,1,19.41,83.655ZM23.824,91l-5.847,5.5v-10ZM37.459,98.3H19.41a1.433,1.433,0,0,1-1.219-.682l6.4-6.022,2.177,1.674a2.862,2.862,0,0,0,3.525,0l2.164-1.7,6.225,6.043A1.433,1.433,0,0,1,37.459,98.3Z",
    transform: "translate(-16.772 -82.45)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.b9bf43e0755717c2f5a3d7eed823e651.svg";
export { ForwardRef as ReactComponent };